module.exports = __webpack_public_path__ + "img/poster-long-1.bf41cc30.jpg";